import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/home/noData.png'


const _withScopeId = n => (_pushScopeId("data-v-556337d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "entrust-record" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, "委托交易账号：", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, "客户姓名/公司名称（中文）：", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, "客户姓名/公司名称（英文）：", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, "是否签署协议：", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, "提交申请日期：", -1))
const _hoisted_7 = { class: "card" }
const _hoisted_8 = { class: "no-data" }
const _hoisted_9 = {
  src: _imports_0,
  alt: ""
}

import { reactive, onMounted, ref } from 'vue'
import dayjs from 'dayjs'
import { operatorClientEntrustments } from '@/apis/index'
import storage, { StorageType } from '@/utils/storage'
import { downloadFile } from '@/utils/index'
import SignAgreement from '@/views/accountEntrust/entrustRecord/components/SignAgreement.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const operatorAccount = JSON.parse(
  storage.rcGetItem(StorageType.local, 'userInfo')
)

const signAgreementRef = ref()

const state = reactive({
  listQuery: {
    operatorAccount: operatorAccount,
    page: 1,
    pageSize: 10,
    tradeAccount: '',
    clientNameCn: '',
    clientNameEn: '',
    hasSigned: null,
    submitTimestampStart: '',
    submitTimestampEnd: ''
  },
  createTime: [],
  pagination: {
    current: 1,
    size: 10,
    total: 0
  },
  loading: false,
  tableData: []
})

const signAgreementConfirm = () => {
  search()
}

const downloadAgreement = (row: any) => {
  downloadFile(row.clientEntrustmentFile, row.tradeAccount)
}
const signAgreement = (row: any) => {
  signAgreementRef.value.open(row)
}
const viewAgreement = (row: any) => {
  window.open(row.clientEntrustmentFile)
}

const reset = () => {
  state.listQuery = {
    operatorAccount: operatorAccount,
    page: 1,
    pageSize: 10,
    tradeAccount: '',
    clientNameCn: '',
    clientNameEn: '',
    hasSigned: null,
    submitTimestampStart: '',
    submitTimestampEnd: ''
  }
  state.createTime = []
  search()
}
const getListQuery = () => {
  if (state.createTime?.length > 0) {
    state.listQuery.submitTimestampStart = `${dayjs(+state.createTime[0]).startOf('day')}`
    state.listQuery.submitTimestampEnd = `${dayjs(+state.createTime[0]).endOf('day')}`
  }
  return state.listQuery
}
const search = async () => {
  try {
    state.loading = true
    const { data } = await operatorClientEntrustments({
      param: getListQuery()
    })
    console.log(data)
    if (data.operatorClientEntrustments.ok) {
      state.tableData =
        data.operatorClientEntrustments.data.clientEntrustments || []
      state.pagination.total = data.operatorClientEntrustments.data.total
    }
  } catch (error) {
  } finally {
    state.loading = false
  }
}

const handleSizeChange = (pageSize: number) => {
  state.pagination.size = pageSize
  state.pagination.current = 1
  state.listQuery.pageSize = pageSize
  state.listQuery.page = 1
  search()
}

const handleCurrentChange = (currentPage: number) => {
  state.pagination.current = currentPage
  state.listQuery.page = currentPage

  search()
}

onMounted(() => {
  search()
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createVNode(_component_el_row, {
        gutter: 20,
        class: "search-form"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12,
            xl: 8,
            lg: 8,
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _hoisted_2,
              _createVNode(_component_el_input, {
                modelValue: state.listQuery.tradeAccount,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((state.listQuery.tradeAccount) = $event)),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12,
            xl: 8,
            lg: 8,
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_el_input, {
                modelValue: state.listQuery.clientNameCn,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((state.listQuery.clientNameCn) = $event)),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12,
            xl: 8,
            lg: 8,
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _hoisted_4,
              _createVNode(_component_el_input, {
                modelValue: state.listQuery.clientNameEn,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((state.listQuery.clientNameEn) = $event)),
                placeholder: "请输入"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12,
            xl: 8,
            lg: 8,
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_el_select, {
                modelValue: state.listQuery.hasSigned,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((state.listQuery.hasSigned) = $event)),
                style: {"width":"100%"},
                placeholder: "请选择"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList([
              { name: '是', value: true },
              { name: '否', value: false },
            ], (item, idx) => {
                    return _createVNode(_component_el_option, {
                      key: idx,
                      label: item.name,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12,
            xl: 8,
            lg: 8,
            class: "form-item"
          }, {
            default: _withCtx(() => [
              _hoisted_6,
              _createVNode(_component_el_date_picker, {
                modelValue: state.createTime,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((state.createTime) = $event)),
                type: "daterange",
                style: {"width":"100%"},
                format: "YYYY-MM-DD",
                "value-format": "x",
                placeholder: "请选择"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, {
            xs: 24,
            sm: 12,
            xl: 8,
            lg: 8,
            class: "search-btn"
          }, {
            default: _withCtx(() => [
              _createElementVNode("button", {
                class: "reset-button",
                onClick: reset
              }, "重置"),
              _createElementVNode("button", {
                class: "search-button",
                onClick: search
              }, "搜索")
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_table, {
          class: "record-table",
          ref: "tableRef",
          "row-key": "date",
          data: state.tableData,
          "header-cell-style": { background: '#f7f7f9', color: '#0F1423' },
          style: {"width":"100%"}
        }, {
          empty: _withCtx(() => [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [
                [_vShow, !state.loading]
              ]),
              _createElementVNode("div", null, _toDisplayString(state.loading ? "" : "暂无委托记录"), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              prop: "submitTime",
              label: "提交申请时间",
              align: "center",
              "min-width": "200px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "userId",
              label: "金马号",
              align: "center",
              "min-width": "100px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "tradeAccount",
              label: "委托交易账号",
              align: "center",
              "min-width": "120px"
            }),
            _createVNode(_component_el_table_column, {
              prop: "clientNameCn",
              label: "客户姓名/公司名称（中文）",
              align: "center",
              "min-width": "200px"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(row.clientNameCn || '--'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "clientNameEn",
              label: "客户姓名/公司名称（英文）",
              align: "center",
              "min-width": "200px"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(row.clientNameEn || '--'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              prop: "hasSigned",
              label: "是否签署协议",
              align: "center",
              "min-width": "120px"
            }, {
              default: _withCtx(({ row }) => [
                _createElementVNode("span", null, _toDisplayString(row.hasSigned ? "是" : "否"), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "操作",
              align: "center",
              width: "200px",
              fixed: "right"
            }, {
              default: _withCtx(({ row }) => [
                _createVNode(_component_el_space, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (downloadAgreement(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("下载协议")
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    (!row.hasSigned)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          type: "text",
                          onClick: ($event: any) => (signAgreement(row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("签署协议")
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      type: "text",
                      onClick: ($event: any) => (viewAgreement(row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("查看协议")
                      ]),
                      _: 2
                    }, 1032, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(_component_el_pagination, {
          "current-page": state.pagination.current,
          "onUpdate:currentPage": _cache[5] || (_cache[5] = ($event: any) => ((state.pagination.current) = $event)),
          "page-size": state.pagination.size,
          "onUpdate:pageSize": _cache[6] || (_cache[6] = ($event: any) => ((state.pagination.size) = $event)),
          "page-sizes": [10, 20, 30, 40],
          small: "",
          background: "",
          layout: "total, sizes, prev, pager, next, jumper",
          total: state.pagination.total,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ])), [
      [_directive_loading, state.loading]
    ]),
    _createVNode(SignAgreement, {
      ref_key: "signAgreementRef",
      ref: signAgreementRef,
      onConfirm: signAgreementConfirm
    }, null, 512)
  ], 64))
}
}

})